module.exports = __webpack_public_path__ + "img/LaC_logo_duo_header.7451b424.svg";